import { Injectable } from '@angular/core';
import { ApiHttpClientService } from '../../api-http-client.service';
import { environment } from 'src/environments/environment';
import { Exclusivo } from 'src/app/models/api/comercial/exclusivo';

@Injectable({
  providedIn: 'root'
})
export class ApiExclusivoService {
  private baseUrl = 'Exclusivo';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.comercial)
      .useBaseUrl(this.baseUrl);
  }

  getAll() {
    return this.controller.unwrap().get<Exclusivo[]>('');
  }
}
